module.exports = __webpack_public_path__ + "static/media/share.c638b8f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/share.svg
// module id = 209
// module chunks = 0